import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// react-query was mounted here as a provider but the app never issued a single
// useQuery — every screen fetches through lib/api directly. Shipping the client
// bought nothing but bundle size. If server-state caching is wanted later, add
// it back together with the first query that needs it.
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
